<template>
  <g
    id="Right_Rear_View_Mirror-3"
    v-on:click="changeSeverity('rearRightRearViewMirror')"
    :class="severityClass"
  >
    <g>
      <circle
        class="cls-355"
        cx="110.8"
        cy="184.43"
        r="7.27"
        transform="translate(-97.96 132.36) rotate(-45)"
      />
      <path
        class="cls-27"
        d="M104.22,184.41v.02c0,3.63,2.94,6.58,6.58,6.58s6.58-2.94,6.58-6.58v-.07c0-.18-.01-.36-.03-.54-.31-3.34-3.12-5.96-6.54-5.96s-6.27,2.65-6.55,6.01c-.02,.18-.03,.36-.03,.54Z"
      />
      <path
        class="cls-2"
        d="M104.22,184.41v.02c0,3.63,2.94,6.58,6.58,6.58s6.58-2.94,6.58-6.58v-.07c0-.18-.01-.36-.03-.54l-6.54,1.52-6.55-1.47c-.02,.18-.03,.36-.03,.54Z"
      />
      <path
        class="cls-553"
        d="M104.22,184.41v.02c0,3.63,2.94,6.58,6.58,6.58s6.58-2.94,6.58-6.58v-.07l-6.58,1.54-6.58-1.48Z"
      />
    </g>
    <path
      class="cls-532"
      d="M89.6,208.58c.3,0,.54-.24,.54-.54v-2c0-1.1,.54-2.12,1.45-2.73l17.85-12.16c1.2-.82,1.91-2.17,1.91-3.62v-1.77c0-.3-.24-.54-.54-.54s-.54,.24-.54,.54v1.77c0,1.1-.54,2.12-1.45,2.73l-17.85,12.16c-1.2,.82-1.91,2.17-1.91,3.62v2c0,.3,.24,.54,.54,.54Z"
    />
  </g>
</template>

<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
